module.exports = __webpack_public_path__ + "img/square-v.97d77f34.svg";